export interface ApiBaseConfig {
  path: string;
  port: number;
}

export const API_BASE_PATHS = {
  chat: {path: '/chatapi', port: 5002},
  qc: {path: '/postcloseqcapi', port: 5004},
  orderEntry: {path: '/orderentryapi', port: 5006},
  entitlements: {path: '/entitlementsapi', port: 5008},
  webhooks: {path: '/webhookapi', port: 5747},
} as const satisfies Record<string, ApiBaseConfig>;
